import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Grid, Row, Col } from 'react-bootstrap';
import InfoBox from '../InfoBox/';
import OptionButton from '../OptionButton/';

class OptionGroup extends Component {
  render() {
    const { options, prompt, selected, onSelect, info, level, prefix, namespace } = this.props;

    const optionButtons = options.map(option => (
      <Col key={option.id} xs={12} sm={6} md={4} lg={4}>
        <OptionButton
          active={selected === option.id}
          onClick={onSelect}
          option={option}
          prefix={prefix}
          namespace={namespace}
        />
      </Col>
    ));

    return (
      <div className="option-group" id={level >= 0 ? `optionGroup${level}` : null}>
        <FormGroup>
          <Grid fluid>
            <Row>
              {optionButtons}
            </Row>
          </Grid>
        </FormGroup>
        { info &&
          <InfoBox content={info} />
        }
      </div>
    );
  }
}

OptionGroup.propTypes = {
  prompt: PropTypes.string,
  info: PropTypes.string,
  level: PropTypes.number,
  options: PropTypes.array.isRequired,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  onSelect: PropTypes.func.isRequired,
  prefix: PropTypes.string,
  namespace: PropTypes.string
};

OptionGroup.defaultProps = {
  prompt: null,
  info: null,
  level: -1,
  options: [],
  selected: false,
  prefix: 'pathConfig',
  namespace: ''
};

export default OptionGroup;



// WEBPACK FOOTER //
// ./src/components/OptionGroup/OptionGroup.jsx